import React from 'react';
import { ui } from '../../styles/shared';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const btn = ui.btn;

interface Props {
    isOn: boolean;
    brightness: number;
    onBrightnessChange: (v: number) => void;
    onControl: (state: 'ON' | 'OFF', brightness?: number) => void;
    readOnly?: boolean;
}

const LightControl: React.FC<Props> = ({ isOn, brightness, onBrightnessChange, onControl, readOnly }) => (
    <div style={card}>
        <h3 style={{ marginTop: 0 }}>💡 Styr lampa</h3>
        <div style={{ marginBottom: '20px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                Ström: {isOn ? '🟢 PÅ' : '🔴 AV'}
            </label>
            {!readOnly && (
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={() => onControl('ON', brightness)}
                        style={{ ...btn(isOn ? '#28a745' : '#6c757d'), padding: '12px 24px' }}>Slå på</button>
                    <button onClick={() => onControl('OFF')}
                        style={{ ...btn(!isOn ? '#dc3545' : '#6c757d'), padding: '12px 24px' }}>Slå av</button>
                </div>
            )}
        </div>
        {!readOnly && (
            <div style={{ marginBottom: '20px' }}>
                <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                    Ljusstyrka: {brightness} / 255 ({Math.round((brightness / 255) * 100)} %)
                </label>
                <input type="range" min="0" max="255" value={brightness}
                    onChange={e => onBrightnessChange(Number(e.target.value))}
                    style={{ width: '100%', height: '8px' }} />
                <button onClick={() => onControl('ON', brightness)}
                    style={{ ...btn('#007bff'), marginTop: '10px', padding: '8px 16px' }}>Spara ljusstyrka</button>
            </div>
        )}
    </div>
);

export default LightControl;
